module.exports = __webpack_public_path__ + "static/media/bg.5212b20d.svg";